export default {
    SCROLL_BOTTOM: "SCROLL_BOTTOM",
    SCROLL_TO_ITEM: "SCROLL_TO_ITEM"
}
